import { DashboardComponentPair } from "../../../../models/dashboard";
import { SmartwatchDashboardFormComponent } from "./smartwatch-dashboard-form.component";
import { SmartwatchDashboardComponent } from "./smartwatch-dashboard.component";

export const ComponentPair: DashboardComponentPair = {
    view: SmartwatchDashboardComponent,
    form: SmartwatchDashboardFormComponent,
}
